import { Route, Routes } from 'react-router-dom';

import AppBar from '@sayyesschool/frontend/components/app-bar';
import AppContent from '@sayyesschool/frontend/components/app-content';
import AppShell from '@sayyesschool/frontend/components/app-shell';
import LoadingIndicator from '@sayyesschool/frontend/components/loading-indicator';
import { useChatContext } from '@sayyesschool/frontend/features/chat';
import { useUser } from '@sayyesschool/frontend/features/user';

import Chat from '@/components/chat';

import routes from './routes';

// import SearchForm from '@sayyesschool/frontend/components/search-form';
import styles from './App.module.scss';

export default function App() {
    const [user] = useUser();
    const { unreadCount } = useChatContext();

    if (!user) return <LoadingIndicator fullscreen />;

    const availableRoutes = getAvailableRoutes(user, routes);

    return (
        <AppShell className={styles.root}>
            {/* <AppHeader
                user={user}
            /> */}

            <AppBar
                user={user}
                routes={availableRoutes.filter(route => !route.hidden)}
                badges={{ chat: unreadCount }}
            />

            <AppContent full>
                <Routes>
                    {availableRoutes.map(route =>
                        <Route
                            key={route.path}
                            path={route.path === '/' ? '/' : `${route.path}/*`}
                            element={<route.component />}
                        />
                    )}
                </Routes>

                <Chat />
            </AppContent>
        </AppShell>
    );
}

function getAvailableRoutes(user, routes) {
    return routes.filter(route =>
        !route.permissions ||
        route.permissions.length === 0 ||
        !(new Set(user.permissions).isDisjointFrom(new Set(route.permissions)))
    );
}